function n(o, e) {
  return [o, e].filter(Boolean).join("-");
}
export {
  n as composeTrackId
};
//# sourceMappingURL=trackId.es.js.map
